<template>
  <el-dialog
      v-model="dialogVisible"
      :title="formData.ID?'编辑赛区':'新增赛区'"
      width="800px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item1">
      <el-form :model="formData"
               label-width="auto"
               :rules="rules"
               class="el-form-box" ref="ruleFormRef">
        <el-row :gutter="10">
          <el-col :span="24" >
            <el-form-item label="年份：" prop="year">
              <el-select v-model="formData.year" style="width: 100px" :disabled="formData.ID">
                <el-option v-for="i of YEARS" :key="i.ID" :value="i.ID" :label="i.Name" />
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="24" >
            <el-form-item label="赛区名称：" prop="name" >
              <el-input v-model.trim="formData.name" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赛区介绍：" prop="content" >
              <el-input v-model.trim="formData.content" maxlength="300" rows="5" show-word-limit  type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="省份/海外国家" prop="provinces">
              <el-checkbox-group v-model="formData.provinces">
                <el-checkbox :value="i"  v-for="i of provinces" :key="i">
                  {{i}}
                </el-checkbox>
<!--                <hr>-->
                <br>
                <el-checkbox :value="i"  v-for="i of countries" :key="i">
                 <text style="color:#0d6efd">(海外)</text>{{i}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="save(ruleFormRef)"
                   :loading = "loading"
        >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, reactive,onMounted} from 'vue';
import {ElMessage} from "element-plus";
import {validateForm} from "@/utils/formValidate";
import {getYears} from "@/utils/commonSetting"
import {getCountries, getProvinces} from "@/api/school";
import {addZone, updateZone} from "@/api/zoneAdmin";
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)
const ruleFormRef = ref()
const YEARS = getYears()
const provinces = ref([]) // 省份列表
const countries = ref([])// 省份列表
var formData = reactive({
  ID:null,
  name: null, // 赛区名称
  content:null,// 赛区介绍
  provinces:[], // 分数
  year:new Date().getFullYear(), // 年份
})
const loading = ref(false)
const rules = ({
  year: [{required: true, message: '请选择年份', trigger: ['change', 'blur']}],
  name: [{required: true, message: '请输入赛区名称', trigger: ['change', 'blur']}],
  content: [{required: true, message: '请输入赛区介绍', trigger: ['change', 'blur']}],
  provinces: [{required: true, message: '请至少选择一个省份/海外国家', trigger: ['change', 'blur']}],
})

const props = defineProps({
  item: {
    default: {},
  }
})
// 开始
onMounted(()=>{
  getProvincesAll() // 获取所有的省份列表
  getCountriesAll() // 获取所有的国家
  if(props.item && props.item.ID){
    formData.ID = props.item.ID
    formData.year = props.item.Year
    formData.name = props.item.Name
    formData.content = props.item.Content
    formData.provinces = props.item.Provinces?props.item.Provinces.split(","):[]
  }
})
// 获取省份列表
const getProvincesAll = async ()=>{
  const res = await getProvinces()
  if(res.success){
    provinces.value = res.data || []
  }
}
const getCountriesAll = async ()=>{
  const res = await getCountries()
  if(res.success){
    const data = res.data || []
    countries.value = data.filter(item=>item !=="中国")
  }
}
const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}
// 保存
const save = async (ruleFormRef) => {
  const isvalidate =await validateForm(ruleFormRef)
  if(!isvalidate){
    return
  }
  loading.value = true
  let res,messPre;
  const params = {
    ...formData,
    provinces:formData.provinces.join(",")
  }
  if( formData.ID){
    res = await updateZone(params)
    messPre = '修改'
  }else{
    res = await addZone(params)
    messPre = '创建'
  }
  loading.value = false
  if(res.err_code===0){
    ElMessage.success(messPre + "成功")
    emits("success", true)
  }else{
    ElMessage.warning(res.err_msg || messPre + "失败")
  }

}
</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  min-height: 600px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
